import { validatePresence } from 'ember-changeset-validations/validators';
import { customMessageValidator } from 'uplisting-frontend/validators/custom-message';

export const BookingRequestValidation = {
  rejectionMessage: customMessageValidator(
    'booking_request_rejection_message',
    validatePresence({ presence: true }),
  ),
  rejectionReason: customMessageValidator(
    'booking_request_rejection_reason',
    validatePresence({ presence: true }),
  ),
};
